<template>
  <div class="about" style="padding-top: 30px">
    <h1>Session expired.</h1>
    <br />
    <span>Please scan the QR code to submit questions or requests.</span>
  </div>
</template>

<script>
import Vue from "vue";
import { Toast } from "vant";

export default {
  metaInfo: {
    meta: [
      {
        name: "viewport",
        content:
          "width=device-width, initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no",
      },
    ],
  },
  name: "About",
  components: {},
  data() {
    return {
      url: {
        login: "/api/common/user/hotel_dept_name/login",
        hotelQuery: "/api/sys_admin/hotel/query",
        hotelinfo: "/adminApi/hotelinfo/infobyhotel",
        getPageInfo: "/adminApi/file/page",
        queryRoomNum: "/api/sys_admin/hotel/room/query2/",
        getKeyWord: "/api/app/current_user/keywordsalldept/",
        getReplyList: "/adminApi/reply/listbyhotel",
        getIsInputPhone: "/adminApi/textconfig/list",
        createOrder: "/api/common/hotel/data/qrorder/create",
        getFileList: "/adminApi/file/filelist",
      },
      brandUrl: "",
      hotelName: "",
      pageInfo: {},
      address: "",
      phone: "",
      rooms: [], //所有房间
      submiting: false,
      loading: null,
    };
  },

  created() {
    // Vue.ls.remove("HTTOKEN");
    let loading = Toast.loading({
      forbidClick: true,
      duration: 0,
    });
    loading.clear();
  },
  methods: {},
};
</script>